<template>
  <div>
    <drivers-periods-available-overview-detailed
      v-if="type() === 'detailed'"
    ></drivers-periods-available-overview-detailed>
    <drivers-periods-available-overview-simple
      v-if="type() === 'simple'"
    ></drivers-periods-available-overview-simple>
  </div>
</template>

<script>
import DriversPeriodsAvailableOverviewDetailed from "./DriversPeriodsAvailableOverviewDetailed.vue";
import DriversPeriodsAvailableOverviewSimple from "./DriversPeriodsAvailableOverviewSimple.vue";

export default {
  components: {
    DriversPeriodsAvailableOverviewDetailed,
    DriversPeriodsAvailableOverviewSimple
  },
  methods: {
    type() {
      if (
        this.getModuleSettingFromSession(
          "driver_availability_simple_enabled"
        ) === 1
      ) {
        return "simple";
      }
      return "detailed";
    }
  }
};
</script>
